const SiteLookupRowComponent = {
    bindings: {
        site: '<',
    },
    template: `
        <div class="data-row">
            <div class="cell md">
                {{ $ctrl.site.location_site_id }}
            </div>
            <div class="cell md">
                {{ $ctrl.site.name }}
            </div>
            <div class="cell md">
                {{ $ctrl.site.client_name }}
            </div>
            <div class="cell md">
                {{ $ctrl.site.client_site_id }}
            </div>
            <div class="cell md">
                {{ $ctrl.site.state }}
            </div>
            <div class="cell md">
                {{ $ctrl.site.city }}
            </div>
            <div class="cell md">
                {{ $ctrl.site.address_1 }}
            </div>
            <div class="cell md">
                {{ $ctrl.site.address_2 }}
            </div>
            <div class="cell md">
                {{ $ctrl.site.postal_code }}
            </div>
        </div>
    `,
};

export default SiteLookupRowComponent;



// WEBPACK FOOTER //
// ./app/components/site-lookup/site-lookup-row/site-lookup-row.component.js